import { useCallback, useEffect, useRef } from 'react';

export default function useCommentDraftGuard(data, onError) {
  const root = useRef(null);
  const draft = useRef(false);
  const canLeave = useCallback(() => {
    if (!draft.current) return true;
    onError(data.t.read('error_comments_draft'));
    return false;
  }, [data, onError]);
  const onDraftChange = useCallback((pending) => { draft.current = pending; }, []);
  useEffect(() => {
    const escape = (event) => {
      if (event.key === 'Escape' && !canLeave()) { event.preventDefault(); event.stopPropagation(); }
    };
    const backdrop = (event) => {
      const overlay = root.current?.closest('.overlay');
      if (draft.current && overlay?.contains(event.target) && !root.current.contains(event.target)) {
        event.preventDefault(); event.stopPropagation(); canLeave();
      }
    };
    document.addEventListener('keydown', escape, true);
    document.addEventListener('keyup', escape, true);
    document.addEventListener('click', backdrop, true);
    return () => {
      document.removeEventListener('keydown', escape, true);
      document.removeEventListener('keyup', escape, true);
      document.removeEventListener('click', backdrop, true);
    };
  }, [canLeave]);
  return { root, canLeave, onDraftChange };
}
